export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' : 'https://tameer.mhu.gov.ly';
export const BASE_API_URL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api' : 'https://tameer.mhu.gov.ly/api';

export const RECAPTCHA_PUBLIC_KEY: string = process.env.NODE_ENV === 'development' ? '6LexgaspAAAAAJuVC2ra6KC74HOkQQdzCKQFpKnz' : '6LeZcDAqAAAAAAZagwXaxzscaqxzb2PKLTNYzfd_';

